var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Shop_Icon",
    "data-name": "Shop Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.019,
    height: 35,
    viewBox: "0 0 32.019 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4551",
    "data-name": "Path 4551",
    d: "M30.914,66.557H1.1A1.1,1.1,0,0,1,0,65.384L1.492,41.535a1.1,1.1,0,0,1,1.1-1.035h26.83a1.1,1.1,0,0,1,1.1,1.035l1.491,23.849a1.1,1.1,0,0,1-1.1,1.173M2.279,64.349h27.46l-1.353-21.64H3.631Z",
    transform: "translate(0.001 -31.557)",
    fill: "#174295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4552",
    "data-name": "Path 4552",
    d: "M49.759,14.132a1.1,1.1,0,0,1-1.1-1.1V7.066A4.864,4.864,0,0,0,43.8,2.208H40.816a4.864,4.864,0,0,0-4.858,4.858v5.962a1.1,1.1,0,1,1-2.208,0V7.066A7.074,7.074,0,0,1,40.816,0H43.8a7.074,7.074,0,0,1,7.066,7.066v5.962a1.1,1.1,0,0,1-1.1,1.1",
    transform: "translate(-26.297)",
    fill: "#174295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop_icon.26bb86fdfad8fc5e4aa649847ebd033f.svg";
export { ForwardRef as ReactComponent };